import {CoreServices} from "./core/CoreServices";
import {FontDetector} from "@webfruits/toolbox/dist/font/FontDetector";
import {Font} from "./style/Font";
import {PromisedDelay} from "@webfruits/toolbox/dist/timer/PromisedDelay";
import {gsap} from "gsap";

/******************************************************************
 * BASFInfografik
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class BASFInfografik {

    /******************************************************************
     * Properties
     *****************************************************************/

    private _core: CoreServices;

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor() {
        this._core = new CoreServices();
        this.init();
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    get view(): HTMLElement {
        return this._core.view.view;
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private async init() {
        await PromisedDelay.waitUntilValid(() => document.readyState == "complete");
        await FontDetector.initializeFonts([
            {fontName: Font.HELVETICA_BOLD},
            {fontName: Font.HELVETICA_REGULAR}
        ])
        await this._core.view.initSystems();
        await PromisedDelay.wait(1);
        this._core.view.playIntroAnimation();
        this.removePreloader();
    }

    private removePreloader() {
        let preloader = document.getElementById("preloader");
        gsap.to(preloader, {
            duration: 0.5,
            alpha: 0,
            scale: 1.2,
            ease: "power4.out",
            onComplete: () => {
                document.body.removeChild(preloader);
                preloader = null;
            }
        })
    }

    /******************************************************************
     * Events
     *****************************************************************/



}
